export enum SyncAnalysisFindingTypeEnum {
    /** Visita evaluada que no generó ningún consumo. Ancla en la visita del EMR. */
    VisitWithoutConsumption = 1,

    /**
     * Ítem del formulario realizado y facturable que no derivó en consumo.
     * Ancla en la visita del EMR más la descripción del ítem.
     */
    UnsettledFormItem = 2,

    /** Concepto cuya parametrización le impide liquidar. Ancla en el concepto de contrato. */
    MisconfiguredConcept = 3,

    /**
     * Combinación de parametrización internamente contradictoria.
     * Ancla en el concepto de contrato.
     */
    ContradictoryConfiguration = 4,
}
